// ES6 syntax to extend jQuery with plugins
let $ = require('jquery');
// TODO: Comentada la validación de jQuery para que no moleste más. En un futuro eliminar del todo
// $ = require('jquery-validation');
//

$(document).ready(function() {
  const $editInPlaces = $('.e-edit-in-place');

  $editInPlaces.each(function() {
    const $thisEditInPlace = $(this);
    const $span = $thisEditInPlace.find('.face-mode span');
    const $input = $thisEditInPlace.find('.edit-mode input');
    const $editLink = $thisEditInPlace.find('.face-mode a');
    const $form = $thisEditInPlace.find('form');
    const $closeLink = $thisEditInPlace.find('.edit-mode .close');
    const action = $form.attr('action');
    const method = $form.attr('method');
    const add = $thisEditInPlace.attr('data-add');
    const edit = $thisEditInPlace.attr('data-edit');

    //
    const renderEditButton = () => {
      $editLink.text($span.text() === '' ? add : edit);
    }

    renderEditButton();

    //
    $editLink.on('click', (event) => {
      event.preventDefault();
      $thisEditInPlace.addClass('editing');
    });

    //
    $closeLink.on('click', (event) => {
      event.preventDefault();
      $input.val($span.text()); // Reset the input value
      $thisEditInPlace.removeClass('editing');
    });

    //
    // const $validator = $form.validate({
    //   lang: 'es',
    //   submitHandler: function(form) {
    //     const data = $form.serialize();
    //     event.preventDefault();
    //     $span.text($input.val()); // Set the input value in the span
    //     renderEditButton();
    //     $thisEditInPlace.removeClass('editing');

    //     $.ajax({
    //       data,
    //       method,
    //       url: action,
    //       success: function(response) {
    //         if (response.status === 'success') {}
    //         else if (response.status === 'fail') {
    //           $validator.showErrors(response.data.errors);
    //         }
    //       },
    //     });
    //   }
    // });
  });
});



// WEBPACK FOOTER //
// ./app/ui/elements/edit-in-place/index.js